import React from 'react';
import styles from '../styles/comingSoon.module.css';

const ComingSoon = ({ title }) => (
    <div className={styles.wrapper}>
        <div className={styles.card}>
            <div className={styles.icon} aria-hidden="true">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="10" />
                    <polyline points="12 6 12 12 16 14" />
                </svg>
            </div>
            <h2 className={styles.title}>{title}</h2>
            <p className={styles.subtitle}>
                Contenido disponible próximamente.
            </p>
            <span className={styles.badge}>Próximamente</span>
        </div>
    </div>
);

export default ComingSoon;
